import {
  EVERYONE_PRINCIPAL_ID,
  type AccessGrant,
  type AccessPrincipalSearchResult,
  type AccessResourceRef,
} from '../types/AccessControl';

export const folderResource: AccessResourceRef = {
  type: 'folder',
  id: 'folder-1',
  name: 'AI Cannot Process Doc Types',
  breadcrumb: ['Documents', 'AI Cannot Process Doc Types'],
};

export const documentResource: AccessResourceRef = {
  type: 'document',
  id: 'document-1',
  name: 'Master Services Agreement.pdf',
  breadcrumb: [
    'Documents',
    'Vendor Agreements',
    'Master Services Agreement.pdf',
  ],
};

export const clauseResource: AccessResourceRef = {
  type: 'clause',
  id: 'clause-1',
  name: 'Governing Law',
};

export const clauseVariantResource: AccessResourceRef = {
  type: 'clause_variant',
  id: 'clause-variant-1',
  name: 'Governing Law — New York (Preferred)',
};

export const everyonePrincipalSearchResult: AccessPrincipalSearchResult = {
  principal: {
    id: EVERYONE_PRINCIPAL_ID,
    name: 'Anyone in organization',
    type: 'everyone',
  },
  subtitle: 'All users in your organization',
};

/** Default focus list matches Manage Access Figma (node 168-7926). */
export const departmentSearchFixtures: AccessPrincipalSearchResult[] = [
  {
    principal: {
      id: 'department-engineering',
      name: 'Engineering team',
      type: 'department',
    },
    memberCount: 22,
    subtitle: '22 members',
  },
  {
    principal: {
      id: 'department-finance',
      name: 'Finance team',
      type: 'department',
    },
    memberCount: 10,
    subtitle: '10 members',
  },
  {
    principal: {
      id: 'department-procurement',
      name: 'Procurement team',
      type: 'department',
    },
    memberCount: 6,
    subtitle: '6 members',
  },
  {
    principal: {
      id: 'department-research',
      name: 'Research team',
      type: 'department',
    },
    memberCount: 15,
    subtitle: '15 members',
  },
];

export const userSearchFixtures: AccessPrincipalSearchResult[] = [
  {
    principal: {
      email: 'carmen.custody@acme.com',
      id: 'user-carmen',
      name: 'Carmen Custody',
      type: 'user',
    },
    subtitle: 'carmen.custody@acme.com',
  },
  {
    principal: {
      email: 'alex.rivera@acme.com',
      id: 'user-alex',
      name: 'Alex Rivera',
      type: 'user',
    },
    subtitle: 'alex.rivera@acme.com',
  },
  {
    principal: {
      email: 'jamie.lee@acme.com',
      id: 'user-jamie',
      name: 'Jamie Lee',
      type: 'user',
    },
    subtitle: 'jamie.lee@acme.com',
  },
];

/** Storybook / local dev default owner row matching the ACL prototype. */
export const prototypeOwnerGrant: AccessGrant = {
  isOwner: true,
  principal: {
    email: 'carmen.custody@example.com',
    id: 'user-carmen-custody',
    name: 'Carmen Custody',
    type: 'user',
  },
  readOnly: true,
  role: 'edit',
  source: 'direct',
};

/** Nested folder/document row that comes from the parent while inherit is on. */
export const inheritedEngineeringGrant: AccessGrant = {
  principal: departmentSearchFixtures[0]!.principal,
  role: 'view',
  source: 'inherited',
};

/** Direct override used to pin add-only inherited rows vs removable locals. */
export const alexDirectGrant: AccessGrant = {
  principal: userSearchFixtures[1]!.principal,
  role: 'edit',
  source: 'direct',
};
